import { createParam } from 'solito'
import { OfferScreen } from './offer-screen'
import { useOfferQuery } from './queries'
import { OfferScreenEmbed } from './offer-screen-embed'

const { useParam } = createParam<{ slug: string }>()

export interface OfferScreenContainerProps {
  isEmbed?: boolean
  preview?: boolean
}

export function OfferScreenContainer(props: OfferScreenContainerProps) {
  const [slug] = useParam('slug')
  const { loading, data, error, refetch } = useOfferQuery({
    slug: slug || '',
    draft: !!props.preview,
  })

  if (props.isEmbed) {
    return (
      <OfferScreenEmbed
        loading={loading}
        offer={data}
        error={error}
        refetch={refetch}
        slug={slug as string}
      />
    )
  }

  return (
    <OfferScreen
      loading={loading}
      offer={data}
      error={error}
      refetch={refetch}
      slug={slug as string}
    />
  )
}
